import { useState } from 'react';
import moment from 'moment-msdate';
import useProfileCommonStore from '../use-profile-common-store';

import { useProfileMoneyMarketHoldings } from '../../../hooks/api';

const useMoneyMarketHoldings = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleShow = e => setIsModalVisible(true);

  const handleClose = e => setIsModalVisible(false);

  const { apiConfigBase } = useProfileCommonStore();
  const { xid, client, apiType } = apiConfigBase;

  const endDate = moment().format('YYYY-MM-DD');
  const startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

  const inputs = {
    params: {
      endDate,
      startDate
    },
    xid,
    client,
    apiType
  };

  const { data } = useProfileMoneyMarketHoldings(inputs);

  return {
    reports: data || [],
    handleShow,
    handleClose,
    isModalVisible
  };
};

export default useMoneyMarketHoldings;
